export default __webpack_public_path__ + "static/media/confetti.3771f65c.png";